import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HomeBanner from "./component";
import { fetchHomepageBanners } from "../../../components/shared/meta-tags/actions";

const mapStateToProps = ({
    config: {
        headingContent
    },
    meta: {
        homePageBanner,
        isSSR
    }
}) => ({
    headingContent,
    homePageBanner,
    isSSR
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchHomepageBannersConnect: fetchHomepageBanners
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HomeBanner);
